export default __webpack_public_path__ + "static/media/proximanova-bold.d7454c98.WOFF";